import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static targets = ['toggles'];
    toggles = [];
    items = [];

    connect() {
        const toggles = this.element.children[0].children;
        for (let i = 0; i < toggles.length; i++) {
            if (toggles[i].classList.contains('tab-toggle')) {
                this.toggles.push(toggles[i]);
            }
        }
        const items = this.element.children;

        for (let i = 0; i < items.length; i++) {
            if (items[i].classList.contains('tab-item')) {
                this.items.push(items[i]);
            }
        }

        this._depth = this._getDepth();
        this._activateFromUrl();
        this._popstateHandler = () => this._activateFromUrl();
        window.addEventListener('popstate', this._popstateHandler);
    }

    disconnect() {
        window.removeEventListener('popstate', this._popstateHandler);
    }

    reset(e) {
        this.toggles.forEach((toggle) => {
            toggle.classList.remove('active');
        });
        this.items.forEach((item) => {
            item.classList.remove('active');
        });
    }

    toggle(e) {
        const el = e.currentTarget;
        const itemId = el.dataset.tabToggleId;
        const tabUrl = el.dataset.tabUrl;

        let activeItem = null;
        this.items.forEach((item) => {
            if (item.dataset.tabItemId === itemId) {
                activeItem = item;
            }
        });

        if (activeItem) {
            this.reset();
            activeItem.classList.add('active');
            el.classList.add('active');
        }

        if (tabUrl) {
            history.pushState({ tabId: itemId }, '', tabUrl);
        } else {
            const slug = this._slugify(el.textContent);
            if (slug) {
                this._updateUrl(slug);
            }
        }
    }

    _getDepth() {
        let depth = 0;
        let el = this.element.parentElement;
        while (el) {
            if (el.dataset && el.controller === 'tabs' || el.getAttribute && el.getAttribute('data-controller') === 'tabs') {
                depth++;
            }
            el = el.parentElement;
        }
        return depth;
    }

    _getTabSegments() {
        const url = new URL(window.location);
        const tab = url.searchParams.get('tab');
        return tab ? tab.split('/') : [];
    }

    _updateUrl(slug) {
        const segments = this._getTabSegments();
        segments[this._depth] = slug;
        // Truncate deeper segments when a parent tab changes
        segments.length = this._depth + 1;

        const url = new URL(window.location);
        url.searchParams.set('tab', segments.join('/'));
        history.pushState({ tab: segments.join('/') }, '', url);
    }

    _activateFromUrl() {
        const segments = this._getTabSegments();
        const slug = segments[this._depth];
        if (!slug) return;

        const toggle = this.toggles.find(t => this._slugify(t.textContent) === slug);
        const toggleIdx = this.toggles.indexOf(toggle);

        if (toggle && toggleIdx < this.items.length) {
            this.reset();
            toggle.classList.add('active');
            this.items[toggleIdx].classList.add('active');
        }
    }

    _slugify(text) {
        return text.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
    }
}
